import { render, staticRenderFns } from "./GameConfigWizard.vue?vue&type=template&id=384c820c&scoped=true"
import script from "./GameConfigWizard.vue?vue&type=script&lang=js"
export * from "./GameConfigWizard.vue?vue&type=script&lang=js"
import style0 from "./GameConfigWizard.vue?vue&type=style&index=0&id=384c820c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384c820c",
  null
  
)

export default component.exports